export var ETwoFactorType = /*#__PURE__*/function (ETwoFactorType) {
  ETwoFactorType["Phone"] = "phone";
  ETwoFactorType["Email"] = "email";
  return ETwoFactorType;
}({});